import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.div`
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${props => (props.theme.isMobile ? '12px' : '10px')};
  line-height: 120%;
  color: ${props => props.theme.secondaryColor};
`;

const Name = styled(Text)`
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightBlack};
`;

export default function Bio({ name, organization }) {
  return (
    <>
      <Name>{name}</Name>
      {!!organization && <Text>{organization}</Text>}
    </>
  );
}

Bio.propTypes = {
  name: PropTypes.string.isRequired,
  organization: PropTypes.string,
};

Bio.defaultProps = { organization: null };
